
import '../assets/css/style.css';

import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import {initSettings} from "@/helpers/bookmark-settings-helper";
import {
    getUrlSearchParams,
    getUrlSearchParamsObject,
    getWebsiteName,
    getWebsiteUrl
} from "@/helpers/url/url-params-helper";
import {initCollapse} from "@/helpers/collapse-helper";
import {check, checkSession} from "@/http/services/http-services-auth";
import {deleteToken, setToken} from "@/helpers/auth/auth-helper";
import * as bootstrap from "bootstrap";
import {stopDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {getAllBySelector} from "@/helpers/element-helper";
import {setGeoLocation} from "@/helpers/ol/ol-geolocation-helper";
import {transformExtent} from "ol/proj";
window.bootstrap = bootstrap
window.kaartViewerUrl = getWebsiteUrl()
window.websiteName = getWebsiteName()
window.urlParamsObject = getUrlSearchParamsObject()

window.mutationForms = []
window.measurePrintFeatures = []

proj4.defs('EPSG:28992','+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417, 50.3319,465.552, -0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs');
proj4.defs("EPSG:31370","+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.869,52.2978,-103.724,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs");
proj4.defs("EPSG:3812", "+proj=lcc +lat_1=49.8333339 +lat_2=51.16666723333333 +lat_0=50.797815 +lon_0=4.359215833 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");

register(proj4);

if(window.urlParamsObject.token) {
    window.sessionStorage.accessToken = window.urlParamsObject.token
}

// Check Auth
check().then(result => {

    window.userSessions = result.sessions
    if(!window.userSessions) {
        window.userSessions = []
    }

    if(result.token !== undefined && result.username !== undefined) {
        setToken(result)
    } else {
        window.sessionStorage.isAdmin = result.isAdmin
        window.sessionStorage.isSsoUser = result.isSsoUser
        deleteToken()
    }

    initSettings(result)
});

document.addEventListener('keydown', (evt) => {
    if(evt.code === 'Escape') {
        // console.log('stop draw')
        stopDraw()


        getAllBySelector('ol-draw-geometry').forEach(element => {
            element.querySelector('input').checked = false
        })
    }
})

// Add CSS
const link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';
link.href = window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteName + '/style.css?time=' + new Date().getTime() ;

document.querySelector('head').appendChild(link);

let logoutInterval;
logoutInterval = setInterval(function () {
    checkSession().then()
}, 120000);
